<script setup lang="ts">
const props = withDefaults(defineProps<{
  id: string,
  height?: string,
  debug?: boolean,
}>(), {
  id: '',
  height: '120px',
  debug: false,
})

const { $io } = useNuxtApp()

const { w } = useViewport()

const isInfoPage = computed(() => $io.headerModel === 'info')

const Height = computed(() => {
  if(w.value && w.value <= 1200) { 
    if ($io.headerFixed) {
      return 140 + 'px';
    } else {
      return 140 + 'px';
    }
  } else {
    if ($io.headerFixed) {
      return 100 + 'px'
    } else {
      return 90 + 'px'
    }
  }
})
</script>

<template>
<div class="io-content-menu-buffer" :class="[id, { debug: debug }]" :style="{ height: Height }">
  <div class="buffer" />
  <span class="debug-text" v-if="debug">Menu Buffer</span>
</div>
</template>

<style lang="scss" scoped>
.io-content-menu-buffer {
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.3s ease-in-out;
  transition-delay: 0.3s;

  .debug-text {
    color: white;
    font-size: fs(0);
  }

  &.debug {
    border: 1px solid red;
    background: rgba(255, 0, 0, 0.2);
  }
}
</style>
